var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "roleAdd_moda",
      attrs: { visible: "", width: "98%", "append-to-body": "" },
      on: { close: _vm.onCancel },
    },
    [
      _c(
        "label",
        { staticClass: "tip", attrs: { slot: "title" }, slot: "title" },
        [
          _c("span", { staticClass: "moda-title" }, [
            _vm._v(_vm._s(_vm.$t("PAGE_CLIENTROLES_TITLE"))),
          ]),
        ]
      ),
      _c("div", { staticClass: "tip" }, [
        _c("i", {
          staticClass: "el-icon-warning",
          staticStyle: { color: "#fd349c" },
        }),
        _vm._v("  \n        "),
        _c("span", { staticStyle: { "font-size": "12PX", color: "#fd349c" } }, [
          _vm._v(_vm._s(_vm.$t("CLIENT_ROLE_MSG"))),
        ]),
      ]),
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.ruleForm, rules: _vm.rules, inline: true },
        },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "35%" },
              attrs: {
                label: _vm.$t("TABLE_HEADER_roleName"),
                prop: "roleName",
              },
            },
            [
              _c("el-input", {
                staticClass: "input-with-select",
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.ruleForm.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "roleName", $$v)
                  },
                  expression: "ruleForm.roleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticStyle: { width: "40%" },
              attrs: {
                label: _vm.$t("FORM_LABEL_description"),
                prop: "description",
              },
            },
            [
              _c("el-input", {
                staticClass: "input-with-select",
                staticStyle: { width: "400px" },
                attrs: { maxlength: "100" },
                model: {
                  value: _vm.ruleForm.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "description", $$v)
                  },
                  expression: "ruleForm.description",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              staticStyle: { float: "right" },
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
      _c("el-row", [
        _c("p", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("PAGE_CLIENTROLES_PERMISSION")) + "  "),
        ]),
      ]),
      _c("div", { staticClass: "step" }, [
        _c(
          "div",
          [
            _c(
              "el-steps",
              {
                attrs: {
                  active: _vm.activeStep,
                  "finish-status": "success",
                  "align-center": "",
                },
              },
              [
                _c("el-step", {
                  staticClass: "step-des",
                  attrs: { title: _vm.$t("CLIENTROLE_ADD_STEP1") },
                }),
                _c("el-step", {
                  staticClass: "step-des",
                  attrs: { title: _vm.$t("CLIENTROLE_ADD_STEP2") },
                }),
                _c("el-step", {
                  staticClass: "step-des",
                  attrs: { title: _vm.$t("CLIENTROLE_ADD_STEP3") },
                }),
                _c("el-step", {
                  staticClass: "step-des",
                  attrs: { title: _vm.$t("CLIENTROLE_ADD_STEP4") },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "step-content" }, [
          _c("div", { staticClass: "part-entity" }, [
            _c("div", { staticClass: "box-item" }, [
              _c("p", { staticClass: "item-title entity" }, [
                _vm._v(_vm._s(_vm.$t("COMMON_ENTITY"))),
              ]),
              _c(
                "div",
                {
                  staticClass: "item-content with-select-all-tree-clientRoles",
                },
                [
                  _c("el-input", {
                    staticStyle: {
                      padding: "5px 20px 5px 5px",
                      "font-size": "12PX",
                    },
                    attrs: { placeholder: _vm.$t("ENTER_SEARCH_CONTENT") },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText = $$v
                      },
                      expression: "filterText",
                    },
                  }),
                  _c("el-tree", {
                    ref: "tree",
                    attrs: {
                      "default-expand-all": true,
                      "check-strictly": true,
                      "expand-on-click-node": false,
                      data: _vm.data,
                      props: _vm.defaultProps,
                      "default-checked-keys": _vm.entityTreeCheckedList,
                      "node-key": "key",
                      "show-checkbox": "",
                      "render-content": _vm.renderContent,
                      "filter-node-method": _vm.filterNode,
                    },
                    on: { check: _vm.handleCheckChange },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ node, data }) {
                          return _c("span", {}, [
                            _c("span", { attrs: { title: node.label } }, [
                              _vm._v(_vm._s(node.label)),
                            ]),
                          ])
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm.activeStep > 0
            ? _c("div", { staticClass: "part-tile" }, [
                _c("div", { staticClass: "box-item" }, [
                  _c(
                    "div",
                    { staticClass: "item-title title-select-content" },
                    [
                      _c("p", { staticClass: "entity" }, [
                        _vm._v(_vm._s(_vm.$t("COMMON_TILES"))),
                      ]),
                      !_vm.isSelectAll(_vm.titleForm.configList)
                        ? _c(
                            "p",
                            {
                              staticClass: "select-cls",
                              on: {
                                click: function ($event) {
                                  return _vm.checkedTile(true)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("select_all")) +
                                  "\n                        "
                              ),
                            ]
                          )
                        : _c(
                            "p",
                            {
                              staticClass: "select-cls",
                              on: {
                                click: function ($event) {
                                  return _vm.checkedTile(false)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("unselect_all")))]
                          ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "item-content" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "titleForm",
                          staticClass: "titleForm",
                          attrs: { model: _vm.titleForm },
                        },
                        _vm._l(
                          _vm.titleForm.configList,
                          function (item, index) {
                            return _c(
                              "el-form-item",
                              {
                                key: index,
                                staticClass: "title-form-item",
                                staticStyle: { "margin-bottom": "0" },
                                attrs: { prop: item.menuCode },
                              },
                              [
                                item.menuCode == "client006"
                                  ? _c(
                                      "el-checkbox",
                                      {
                                        on: {
                                          change: function ($event) {
                                            return _vm.tileCheck(item)
                                          },
                                        },
                                        model: {
                                          value: item.checked,
                                          callback: function ($$v) {
                                            _vm.$set(item, "checked", $$v)
                                          },
                                          expression: "item.checked",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("ROLE_" + item.menuCode)
                                          )
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "el-checkbox",
                                      {
                                        staticClass: "set-disabled",
                                        attrs: {
                                          disabled:
                                            item.menuCode === "client004",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.tileCheck(item)
                                          },
                                        },
                                        model: {
                                          value: item.checked,
                                          callback: function ($$v) {
                                            _vm.$set(item, "checked", $$v)
                                          },
                                          expression: "item.checked",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("ROLE_" + item.menuCode)
                                            ) +
                                            "\n                                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.menuCode === "client004",
                                                expression:
                                                  "item.menuCode === 'client004'",
                                              },
                                            ],
                                          },
                                          [
                                            _vm._v(
                                              "（" +
                                                _vm._s(_vm.$t("required")) +
                                                "）"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm.activeStep > 1
            ? _c("div", { staticClass: "part-pbcOrCategory" }, [
                _vm.pbcShow
                  ? _c(
                      "div",
                      {
                        staticClass: "box-item",
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _c("p", { staticClass: "item-title" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                color: "#fd349c",
                                "font-size": "13px",
                              },
                            },
                            [_vm._v("*")]
                          ),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("COMMON_PBC_TITLE_LIST")) +
                              "\n                    "
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "item-content" },
                          [
                            _c(
                              "el-collapse",
                              {
                                staticClass: "item-collapse",
                                model: {
                                  value: _vm.FINAL,
                                  callback: function ($$v) {
                                    _vm.FINAL = $$v
                                  },
                                  expression: "FINAL",
                                },
                              },
                              [
                                _c(
                                  "el-collapse-item",
                                  { attrs: { name: "FINAL" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "        " +
                                          _vm._s(_vm.$t("COMMON_FINAL")) +
                                          " "
                                      ),
                                    ]),
                                    _vm.pbcFinalForm.final.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pbc-selectAll-cls select-cls",
                                          },
                                          [
                                            !_vm.isSelectAll(
                                              _vm.pbcFinalForm.final
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pbcCheck(
                                                          _vm.pbcFinalForm
                                                            .final,
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("select_all")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pbcCheck(
                                                          _vm.pbcFinalForm
                                                            .final,
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("unselect_all")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-form",
                                      {
                                        ref: "pbcFinalForm",
                                        staticClass: "pbcFinalForm",
                                        attrs: { model: _vm.pbcFinalForm },
                                      },
                                      _vm._l(
                                        _vm.pbcFinalForm.final,
                                        function (item) {
                                          return _c(
                                            "el-form-item",
                                            {
                                              key: item.id,
                                              attrs: { prop: item.id },
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.checkBoxPbc(
                                                        false,
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.checked,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "checked",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.checked",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12PX",
                                                      },
                                                      attrs: {
                                                        title:
                                                          item.groupName +
                                                          "(" +
                                                          _vm.dateFormat(
                                                            item.periodEndDate
                                                          ) +
                                                          ")",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.groupName
                                                          ) +
                                                          "(" +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDate"
                                                            )(
                                                              item.periodEndDate
                                                            )
                                                          ) +
                                                          ")\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-collapse",
                              {
                                staticClass: "item-collapse",
                                model: {
                                  value: _vm.INTERIM,
                                  callback: function ($$v) {
                                    _vm.INTERIM = $$v
                                  },
                                  expression: "INTERIM",
                                },
                              },
                              [
                                _c(
                                  "el-collapse-item",
                                  { attrs: { name: "INTERIM" } },
                                  [
                                    _c("template", { slot: "title" }, [
                                      _vm._v(
                                        "        " +
                                          _vm._s(_vm.$t("COMMON_INTERIM")) +
                                          " "
                                      ),
                                    ]),
                                    _vm.pbcInterimForm.Interim.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pbc-selectAll-cls select-cls",
                                          },
                                          [
                                            !_vm.isSelectAll(
                                              _vm.pbcInterimForm.Interim
                                            )
                                              ? _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pbcCheck(
                                                          _vm.pbcInterimForm
                                                            .Interim,
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("select_all")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "span",
                                                  {
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.pbcCheck(
                                                          _vm.pbcInterimForm
                                                            .Interim,
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("unselect_all")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "el-form",
                                      {
                                        ref: "pbcInterimForm",
                                        staticClass: "pbcInterimForm",
                                        attrs: { model: _vm.pbcInterimForm },
                                      },
                                      _vm._l(
                                        _vm.pbcInterimForm.Interim,
                                        function (item) {
                                          return _c(
                                            "el-form-item",
                                            {
                                              key: item.id,
                                              attrs: { prop: item.id },
                                            },
                                            [
                                              _c(
                                                "el-checkbox",
                                                {
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.checkBoxPbc(
                                                        false,
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.checked,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "checked",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.checked",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "12PX",
                                                      },
                                                      attrs: {
                                                        title:
                                                          item.groupName +
                                                          "(" +
                                                          _vm.dateFormat(
                                                            item.periodEndDate
                                                          ) +
                                                          ")",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(
                                                            item.groupName
                                                          ) +
                                                          "(" +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatDate"
                                                            )(
                                                              item.periodEndDate
                                                            )
                                                          ) +
                                                          ")\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.categoryShow
                  ? _c("div", { staticClass: "box-item" }, [
                      _c(
                        "div",
                        { staticClass: "item-title title-select-content" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "category-title",
                              attrs: {
                                title: _vm.$t(
                                  "PAGE_EXCHANGE_TAB1_for_clientrole"
                                ),
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("ROLE_client005")))]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "item-content categoryForm" },
                        [
                          _c(
                            "el-collapse",
                            {
                              staticClass: "item-collapse collapse_exchange",
                              model: {
                                value: _vm.EXCHANGE,
                                callback: function ($$v) {
                                  _vm.EXCHANGE = $$v
                                },
                                expression: "EXCHANGE",
                              },
                            },
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { name: "EXCHANGE" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(
                                      "\n                                           " +
                                        _vm._s(_vm.$t("COMMON_CATEGORY_LIST")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pbc-selectAll-cls select-cls",
                                    },
                                    [
                                      _vm.categoryData.length > 0
                                        ? [
                                            !_vm.isSelectAll(_vm.categoryData)
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass: "select-cls",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.checkedCategory(
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t("select_all")
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass: "select-cls",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.checkedCategory(
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("unselect_all")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._l(
                                    _vm.categoryData,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "categoryItem",
                                        },
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value: item.checked,
                                                callback: function ($$v) {
                                                  _vm.$set(item, "checked", $$v)
                                                },
                                                expression: "item.checked",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.categoryTranslate(
                                                    item.category
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                              _c(
                                "el-checkbox",
                                {
                                  staticClass: "itu-checkbox",
                                  staticStyle: { "margin-left": "8PX" },
                                  attrs: {
                                    "true-label": "1",
                                    "false-label": "0",
                                  },
                                  model: {
                                    value: _vm.ituChecked,
                                    callback: function ($$v) {
                                      _vm.ituChecked = $$v
                                    },
                                    expression: "ituChecked",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "blod",
                                      attrs: { role: "button" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("client_role_enable_itu"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
                _vm.adminShow
                  ? _c("div", { staticClass: "box-item" }, [
                      _c(
                        "div",
                        { staticClass: "item-title title-select-content" },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "category-title w-full",
                              attrs: { title: _vm.$t("client008_tips") },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("ROLE_client008")) +
                                  "\n                            "
                              ),
                              _c("span", { staticClass: "role-tip" }, [
                                _vm._v(_vm._s(_vm.$t("client008_tips"))),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "item-content categoryForm" },
                        [
                          _c(
                            "el-collapse",
                            {
                              staticClass: "item-collapse collapse_exchange",
                              model: {
                                value: _vm.ADMIN,
                                callback: function ($$v) {
                                  _vm.ADMIN = $$v
                                },
                                expression: "ADMIN",
                              },
                            },
                            [
                              _c(
                                "el-collapse-item",
                                { attrs: { name: "admin" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(
                                      "\n                                           " +
                                        _vm._s(_vm.$t("client008")) +
                                        "\n                                "
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "pbc-selectAll-cls select-cls",
                                    },
                                    [
                                      _vm.adminTabs.length > 0
                                        ? [
                                            !_vm.isSelectAll(_vm.adminTabs)
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass: "select-cls",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.checkedAdminTab(
                                                          true
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.$t("select_all")
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "p",
                                                  {
                                                    staticClass: "select-cls",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.checkedAdminTab(
                                                          false
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("unselect_all")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._l(_vm.adminTabs, function (item, index) {
                                    return !item.disabled
                                      ? _c(
                                          "div",
                                          {
                                            key: index,
                                            staticClass: "categoryItem",
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                model: {
                                                  value: item.checked,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "checked",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.checked",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.activeStep > 2 && _vm.hasPbc
            ? _c("div", { staticClass: "part-detailPbc" }, [
                _c("div", { staticClass: "box-item" }, [
                  _c(
                    "p",
                    {
                      staticClass: "item-title",
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "row",
                        "align-items": "center",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#fd349c",
                            "font-size": "13px",
                          },
                        },
                        [_vm._v("*")]
                      ),
                      _c(
                        "el-select",
                        {
                          staticClass: "topFilter",
                          attrs: {
                            placeholder: _vm.$t("PAGE_PBC_LIST_SELECT_TOPIC"),
                          },
                          model: {
                            value: _vm.filterValue,
                            callback: function ($$v) {
                              _vm.filterValue = $$v
                            },
                            expression: "filterValue",
                          },
                        },
                        _vm._l(_vm.topicListFilter, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            staticClass: "pbc-select-item",
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "item-content" },
                    [
                      _vm._l(_vm.topicListFilter, function (item, index) {
                        return [
                          item.id == _vm.filterValue
                            ? _c(
                                "div",
                                {
                                  key: index + "btn",
                                  staticClass: "fourth-box-select",
                                  on: {
                                    click: function ($event) {
                                      return _vm.switchTopicTreeSelect(
                                        index,
                                        item.id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.isTopicTreeAllSelect
                                          ? _vm.$t("unselect_all")
                                          : _vm.$t("select_all")
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c("el-tree", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.id == _vm.filterValue,
                                expression: "item.id == filterValue",
                              },
                            ],
                            key: index,
                            ref: "topicTree" + index,
                            refInFor: true,
                            staticStyle: { width: "100%" },
                            attrs: {
                              "default-expand-all": true,
                              "expand-on-click-node": false,
                              data: _vm.topicTreeData,
                              props: _vm.topicProps,
                              "node-key": "topicBindId",
                              "default-checked-keys":
                                _vm.topicTreeCheckedList.get(item.id),
                              "show-checkbox": "",
                            },
                            on: {
                              check: (a, b) =>
                                _vm.handleLastTreeCheckChange(a, b, item.id),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ node, data }) {
                                    return _c(
                                      "span",
                                      { staticClass: "tree-node" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "tree-label-cls",
                                            attrs: { title: node.label },
                                          },
                                          [_vm._v(_vm._s(node.label))]
                                        ),
                                      ]
                                    )
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { staticClass: "cancel-btn", on: { click: _vm.onCancel } },
            [_vm._v(_vm._s(_vm.$t("comment_reSet")))]
          ),
          _c(
            "el-button",
            {
              staticClass: "wl-green",
              attrs: { type: "primary", loading: _vm.saveLoading },
              on: { click: _vm.onConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("btn_save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }